module.exports = __webpack_public_path__ + "static/media/clip-icon.843921f6.svg";